import { FC } from 'react';
import styles from './PrivacyPage.module.scss';

/**
 * Pagina placeholder Termini e Condizioni. Documento legale
 * ufficiale sostituirà questo testo.
 */
export const TermsPage: FC = () => {
  return (
    <div className={styles.page}>
      <div className={styles.container}>
        <h1>Termini e Condizioni</h1>
        <p className={styles.intro}>
          <em>
            Documento provvisorio in attesa di redazione legale
            definitiva. Per chiarimenti contattare{' '}
            <a href="mailto:legal@leopartmove.com">
              legal@leopartmove.com
            </a>
            .
          </em>
        </p>

        <h2>Oggetto del servizio</h2>
        <p>
          LeoPart è una piattaforma di monitoraggio sportivo per
          team e atleti che fornisce funzionalità di gestione
          presenze, eventi, questionari soggettivi, test fisici,
          recovery, programmazione allenamenti e notifiche push.
        </p>

        <h2>Utenti</h2>
        <ul>
          <li>
            <strong>Atleti</strong>: registrati tramite invito di un
            director o coach. Compilano dati soggettivi e visualizzano
            i propri risultati.
          </li>
          <li>
            <strong>Coach / Director</strong>: gestiscono team e
            atleti, schede di allenamento, statistiche aggregate.
          </li>
          <li>
            <strong>Amministratori</strong>: utenti di sistema con
            permessi estesi (configurazione organizzazione, piani).
          </li>
        </ul>

        <h2>Limitazioni del servizio</h2>
        <p>
          LeoPart non sostituisce il consulto medico-sportivo. I dati
          mostrati sono indicativi e devono essere interpretati da
          personale qualificato. L&apos;utilizzo improprio è a rischio
          dell&apos;utente.
        </p>

        <h2>Account e responsabilità</h2>
        <p>
          L&apos;utente è responsabile della custodia delle proprie
          credenziali. Notificare immediatamente qualsiasi accesso
          non autorizzato a{' '}
          <a href="mailto:security@leopartmove.com">
            security@leopartmove.com
          </a>
          .
        </p>

        <h2>Cancellazione account</h2>
        <p>
          L&apos;utente può richiedere la cancellazione del proprio
          account in qualsiasi momento. Vedi{' '}
          <a href="/privacy">Informativa Privacy</a> per dettagli sul
          right to erasure (art. 17 GDPR).
        </p>

        <h2>Modifiche</h2>
        <p>
          Eventuali modifiche sostanziali ai presenti termini saranno
          comunicate via email e/o tramite notifica in-app.
        </p>

        <p className={styles.footer}>
          <em>Ultimo aggiornamento: 2026-05-09 · Versione 0.1
          (placeholder pre-legal)</em>
        </p>
      </div>
    </div>
  );
};

export default TermsPage;
